import { render, staticRenderFns } from "./BidCostComponentList.vue?vue&type=template&id=16304560&"
import script from "./BidCostComponentList.vue?vue&type=script&lang=js&"
export * from "./BidCostComponentList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports